// import { useState, useEffect } from "react";

// import useFetch from "./useFetch";

// import { useTranslation } from "react-i18next";

// const useZones = (countryID, cityID) => {
//   const { t, i18n } = useTranslation();
//   const currentLanguage = i18n.language;

//   const [data, setData] = useState({
//     countries: [],
//     cities: [],
//     areas: [],
//   });
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(false);
//   const [tries, setTries] = useState(0);

//   const retry = () => setTries((prev) => prev + 1);

//   const Params = new URLSearchParams({
//     populate: "*",
//     locale: 'en',
//     "pagination[limit]": -1,
//   });
//   if (tries > 0) Params.set("_retry", tries);

//   // get countries
//   const countriesBaseUrl = "/countries";
//   const countriesUrl = `${countriesBaseUrl}?${Params.toString()}`;
//   const {
//     data: countriesData,
//     loading: countriesLoading,
//     error: countriesError,
//   } = useFetch(countriesUrl);

//   // get cities
//   const cityParams = new URLSearchParams(Params);
//   cityParams.append("filters[Country][id][$eq]", countryID);
//   const citiesBaseUrl = "/cities";
//   const citiesUrl = `${citiesBaseUrl}?${cityParams.toString()}`;
//   const {
//     data: citiesData,
//     loading: citiesLoading,
//     error: citiesError,
//   } = useFetch(countryID ? citiesUrl : "");

//   // get areas
//   const areaParams = new URLSearchParams(Params);
//   areaParams.append("filters[City][id][$eq]", cityID);
//   const areasBaseUrl = "/areas";
//   const areasUrl = `${areasBaseUrl}?${areaParams.toString()}`;
//   const {
//     data: areasData,
//     loading: areasLoading,
//     error: areasError,
//   } = useFetch(cityID ? areasUrl : "");

//   useEffect(() => {
//     if (countriesError || citiesError || areasError) {
//       setError(true);
//       setLoading(false);
//       return;
//     }

//     if (
//       (!countriesLoading && countriesData?.length > 0) ||
//       (!citiesLoading && citiesData?.length > 0) ||
//       (!areasLoading && areasData?.length > 0)
//     ) {
//       const countries = countriesData;
//       const cities = citiesData;
//       const areas = areasData;

//       const newData = {
//         countries: countries,
//         cities: cities,
//         areas: areas,
//       };

//       setData(newData);
//       setLoading(false);
//       setError(false)
//     } else if (countriesLoading || citiesLoading || areasLoading) {
//       // A fetch is in flight. Keep reporting loading and drop the previous
//       // payload so consumers never read a stale zones list.
//       setLoading(true);
//       setData({ countries: [], cities: [], areas: [] });
//     }
//   }, [countriesLoading, citiesLoading, areasLoading]);

//   return {
//     data,
//     loading,
//     error,
//     setError,
//     retry,
//   };
// };

// export { useZones };
import { useState, useEffect, useMemo } from "react";
import useFetch from "./useFetch";

const CACHE_KEY = "zones-countries-v1";

const readCache = () => {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
  } catch (e) {
    return null;
  }
};

const useZones = () => {
  const [tries, setTries] = useState(0);
  const [cached] = useState(readCache);
  const retry = () => setTries((prev) => prev + 1);

  const params = new URLSearchParams({
    locale: "en",
    "pagination[limit]": -1,
    "fields[0]": "Name",
    "populate[localizations][fields][0]": "Name",
    "populate[localizations][fields][1]": "locale",
  });
  if (tries > 0) params.set("_retry", tries);

  const { data: fresh, error: fetchError } = useFetch(
    `/countries?${params.toString()}`
  );

  useEffect(() => {
    if (Array.isArray(fresh) && fresh.length > 0) {
      try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(fresh));
      } catch (e) {}
    }
  }, [fresh]);

  const countries = fresh && fresh.length > 0 ? fresh : cached;

  const data = useMemo(
    () => ({ countries: countries || [], cities: [], areas: [] }),
    [countries]
  );

  return {
    data,
    loading: !countries && !fetchError,
    error: !countries && fetchError,
    setError: () => {},
    retry,
  };
};

export { useZones };